import { hasEconomy7MeterType } from '@features/Energy/utils';
import {
  EnergyBasketFragment,
  EnergyFuelType,
  EnergyPaymentMethod,
  PredefinedConsumption,
} from '@generated/gql/graphql';
import { EnergyDetailsFormValues } from '@src/types/energy';
import { BooleanSelection } from '@src/types/index';

const getPrepaymentFuelType = (
  electricityPaymentMethod: EnergyPaymentMethod,
  gasPaymentMethod: EnergyPaymentMethod
): EnergyFuelType => {
  if (
    electricityPaymentMethod === EnergyPaymentMethod.Prepayment &&
    gasPaymentMethod === EnergyPaymentMethod.Prepayment
  ) {
    return EnergyFuelType.DualFuel;
  }

  if (electricityPaymentMethod === EnergyPaymentMethod.Prepayment) {
    return EnergyFuelType.ElectricityOnly;
  }

  if (gasPaymentMethod === EnergyPaymentMethod.Prepayment) {
    return EnergyFuelType.GasOnly;
  }

  return EnergyFuelType.DualFuel;
};

const getInitialValues = (
  energy: EnergyBasketFragment
): EnergyDetailsFormValues => {
  const {
    details: {
      electricityUsageDay,
      electricityUsageNight,
      electricityPaymentMethod,
      gasUsage,
      gasPaymentMethod,
      meterType,
      paymentOption,
      predefinedConsumption,
      electricityIndustryEstimateDay,
      electricityIndustryEstimateNight,
      gasIndustryEstimate,
    },
    fuelType,
  } = energy;

  const isEcon7 = hasEconomy7MeterType(meterType);

  const shouldPrefillElectricityUsage = isEcon7
    ? electricityIndustryEstimateDay && electricityIndustryEstimateNight
    : electricityIndustryEstimateDay;

  const shouldPrefillGasUsage =
    gasIndustryEstimate && shouldPrefillElectricityUsage;

  return {
    fuelType,
    meterType,
    hasPrepayment: [electricityPaymentMethod, gasPaymentMethod].includes(
      EnergyPaymentMethod.Prepayment
    )
      ? BooleanSelection.Yes
      : BooleanSelection.No,
    prepaymentFuelType: getPrepaymentFuelType(
      electricityPaymentMethod,
      gasPaymentMethod
    ),
    paymentOption,
    predefinedConsumption:
      predefinedConsumption === PredefinedConsumption.Prefilled
        ? PredefinedConsumption.Custom
        : predefinedConsumption,
    electricityUsageDay: shouldPrefillElectricityUsage
      ? String(electricityUsageDay)
      : '',
    electricityUsageNight: shouldPrefillElectricityUsage
      ? String(electricityUsageNight)
      : '',
    gasUsage: shouldPrefillGasUsage ? String(gasUsage) : '',
    isConsumptionPrefilled:
      predefinedConsumption === PredefinedConsumption.Prefilled,
  };
};

export { getInitialValues };
